import React, { useState } from "react";
import useFetch from "../../../../hooks/useAxios";
import AdminJudjeCard from "./AdminJudjeCard";

const AdminJudje = () => {
  const [ReportList, setReportList] = useState([]);
  const apiReportList = useFetch({
    method: "get",
    url: "api/admin/reports",
    noHeader: false,
    trigger: true,
    argFunc: res => setReportList(res.data.reports)
  });
  const [activeid, setactiveid] = useState(1);
  return (
    <div className="AdminJudje">
      <div className="flex justify-between items-center">
        <h2 className="text-[36px] font-[700]">اختلاف و شکایات</h2>
        <div className="flex gap-[36px]">
          <button
            className={`text-[15px] font-[500] ${activeid === 1
              ? "text-[#00A6A6]"
              : " text-[#797D82]"}`}
          >
            همه شکایت ها
          </button>
          <button
            className={`text-[15px] font-[500] ${activeid === 2
              ? "text-[#00A6A6]"
              : " text-[#797D82]"}`}
          >
           داوری شده
          </button>
          <button
            className={`text-[15px] font-[500] ${activeid === 3
              ? "text-[#00A6A6]"
              : " text-[#797D82]"}`}
          >
           شکایت جاری
          </button>
          <button
            className={`text-[15px] font-[500] ${activeid ===4
              ? "text-[#00A6A6]"
              : " text-[#797D82]"}`}
          >
           داوری نشده
          </button>
        </div>
      </div>
      <div className="AdminJudje--container">
        {ReportList.map(i=><AdminJudjeCard info={i} />)}
       
      </div>
    </div>
  );
};

export default AdminJudje;
